import React from 'react';
import PropTypes from 'prop-types';
import { BillingCategoryType } from 'propTypes';
import BillingCategoryGroups from 'components/billingCategories/BillingCategoryGroups';
import { billingCategoryGroups } from 'ducks';
import { duckify, filterDuck } from 'utils/duckify';

const BillingCategoryList = ({ activeCategories, inactiveCategories }) => (
  <div className='billing-category-list'>
    <div>
      <h2>Billing Category Groups</h2>
      <p className='helper-text'>
        The order of the groups on this page determines precedence when
        applying payments to billing balances.
        <br />
        Category groups higher on the list will have payments applied to them
        before groups lower in the list.
      </p>
    </div>
    <div className='active-categories'>
      <BillingCategoryGroups categories={activeCategories} />
    </div>

    {inactiveCategories.length > 0 && (
      <div className='inactive-categories'>
        <h2>Inactive Billing Category Groups</h2>
        <BillingCategoryGroups categories={inactiveCategories} />
      </div>
    )}
  </div>
);

BillingCategoryList.propTypes = {
  activeCategories: PropTypes.arrayOf(BillingCategoryType),
  inactiveCategories: PropTypes.arrayOf(BillingCategoryType)
};

BillingCategoryList.defaultProps = {
  activeCategories: [],
  inactiveCategories: []
};

const mapDucksToProps = () => ({
  activeCategories: filterDuck(billingCategoryGroups, { active: true }, '_active'),
  inactiveCategories: filterDuck(billingCategoryGroups, { active: false }, '_inactive')
});

export default duckify(mapDucksToProps)(BillingCategoryList);
